import apiClient from './api'

const mailTemplateService = {
  // Get all mail templates
  async getMailTemplates(params = {}) {
    try {
      params['_no_pagination_'] = 1
      const response = await apiClient.get('/admin/mail-templates', { params })
      return response.data
    } catch (error) {
      console.error('Error fetching mail templates:', error)
      throw error
    }
  },

  // Create new mail template
  async createMailTemplate(templateData) {
    try {
      const response = await apiClient.post('/admin/mail-templates', templateData)
      return response.data
    } catch (error) {
      console.error('Error creating mail template:', error)
      throw error
    }
  },

  // Update mail template
  async updateMailTemplate(id, templateData) {
    try {
      const response = await apiClient.put(`/admin/mail-templates/${id}`, templateData)
      return response.data
    } catch (error) {
      console.error('Error updating mail template:', error)
      throw error
    }
  },

  // Delete mail template
  async deleteMailTemplate(id) {
    try {
      const response = await apiClient.delete(`/admin/mail-templates/${id}`)
      return response.data
    } catch (error) {
      console.error('Error deleting mail template:', error)
      throw error
    }
  }
}

export default mailTemplateService 